import React, { Component } from 'react'
import logoIcon from '../assets/logoIcon.png'
import logoFull from '../assets/logoFull.png'
import logoRegular from '../assets/logoRegular.png'

interface LogoProps {
  type: 'regular' | 'full' | 'icon',
  onClick?: () => void
}

interface LogoConfig {
  className: string
  image: string
  minWidth?: string
}

type LogoRegistery = Record<LogoProps['type'], LogoConfig>

export default class Logo extends Component<LogoProps> {
  logos: LogoRegistery = {
    regular: {
      className: 'w-10',
      image: logoRegular,
      minWidth: '100px'
    },
    full: {
      className: 'w-36',
      image: logoFull
    },
    icon: {
      className: 'w-10',
      image: logoIcon
    }
  }

  get className () {
    const base = this.logo.className
    const cursor = this.props.onClick ? 'cursor-pointer' : ''
    return `${base} ${cursor}`
  }

  get logo () {
    return this.logos[this.props.type]
  }

  render () {
    var imgStyle = {};
    if(this.logo.minWidth){
      imgStyle = {
        minWidth: this.logo.minWidth
      }
    }

    return (
      <div className={this.className} onClick={this.props.onClick}>
        <img
          className="max-h-full"
          src={this.logo.image}
          alt="QPRO+ logo"
          style={imgStyle}  />
      </div>
    )
  }
}
